import { Box } from '@mui/material';
import useGetArrangedRows from 'api/inventoryGeo/useGetArrangedRows';
import useGetSectionandArea from 'api/inventoryGeo/useGetSectionandArea';
import useGetShelfAndPartGeo from 'api/productData/getShelfAndPartGeo';
import RequireOperationSettings, {
  useHasOperationSettings,
} from 'components/shared/RequiredOpertaionSettings/RequireOperationSettings';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import WarehouseGeoGraphMap from 'components/shared/WarehouseGeoGraphMap/WarehouseGeoGraphMap';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';

const OperationGeoMap = () => {
  const [{ operationSettings }] = useCookies(['operationSettings']);

  const [
    getSectionandArea,
    sectionandAreaLoading,
    sectionandArea,
    setSectionandArea,
  ] = useGetSectionandArea();

  const [getShelfAndParts, shelfAndPartsLoading, shelfAndParts] =
    useGetShelfAndPartGeo();

  const {
    getArrangedRows,
    arrangedRows,
    loading: arrangedRowsLoading,
  } = useGetArrangedRows();

  const [selectedArea, setSelectedArea] = useState(null);
  const [isPartViewerModalOpen, setIsPartViewerModalOpen] = useState(false);

  const hasOperationSettings = useHasOperationSettings();

  useEffect(() => {
    if (hasOperationSettings) {
      getSectionandArea({ zoneGuid: operationSettings?.defaultZone?.key });
    }
  }, [hasOperationSettings]);

  useEffect(() => {
    if (selectedArea && hasOperationSettings) {
      getShelfAndParts({ areaGuid: selectedArea });
    }
  }, [selectedArea, hasOperationSettings]);

  const onClickPart = partGuid => {
    setIsPartViewerModalOpen(true);
    getArrangedRows({ guid: partGuid });
  };

  return (
    <RequireOperationSettings>
      {sectionandAreaLoading ? (
        <SpinnerLoader />
      ) : (
        <Box sx={{ width: '100%' }}>
          <WarehouseGeoGraphMap
            areaGuid={selectedArea}
            loading={sectionandAreaLoading}
            geoMapLoading={shelfAndPartsLoading}
            graphLoading={sectionandAreaLoading}
            geoMapData={shelfAndParts}
            graphData={sectionandArea}
            setTreeData={setSectionandArea}
            isViewerModalOpen={isPartViewerModalOpen}
            setSelectedNodeGuid={guid => setSelectedArea(guid)}
            onClickPart={guid => onClickPart(guid)}
            closeViewerModal={() => setIsPartViewerModalOpen(false)}
            arrangedRows={arrangedRows}
            arrangedRowsLoading={arrangedRowsLoading}
          />
        </Box>
      )}
    </RequireOperationSettings>
  );
};

export default OperationGeoMap;
